import client from './client';

export const recipesApi = {
  getAll: (params) => client.get('/recipes', { params }),
  getById: (id) => client.get(`/recipes/${id}`),
  create: (data) => client.post('/recipes', data),
  update: (id, data) => client.put(`/recipes/${id}`, data),
  delete: (id) => client.delete(`/recipes/${id}`)
};
